import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Space,
  Typography,
  message,
  Spin,
  TimePicker,
} from "antd";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import {
  InputField,
  ReactSelectField,
  TimeField
} from "../../../../atoms/FormElement";
import dayjs from "dayjs";
import { ExclamationCircleOutlined, CheckOutlined, CloseOutlined, PlusSquareOutlined, CloseSquareOutlined, PlusOutlined } from "@ant-design/icons";
import { addShift, editShift } from "../../ducks/actions";
import { useSelector } from "react-redux";


const { Paragraph, Title } = Typography;

const defaultVal = {
  name: "",
  description: "",
  start_time: "",
  end_time: "",
  breaks: [{ duration: { label: 'No break', value: '0' }, breakStart_time: "" }], //{ label: 'No break', value: '0' }
  // breakStart_time: "",
};

const modifyShift = (props) => {

  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [breakTime, setBreakTime] = useState(null);
  const selectedCompany = useSelector((state: any) => state.calendar.selectedCompany);
  const selectedCenter = useSelector((state: any) => state.calendar.selectedCenter);

  const { control, handleSubmit, formState: { errors }, resetField, reset, setValue, setError } = useForm({
    defaultValues: defaultVal,
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'breaks'
  });

  const _break: any = useWatch({ control, name: "breaks" });

  const isNew = Object.keys(props?.data).length === 0 && props?.data.constructor === Object;

  const breakTimeList = [
    { label: 'No break', value: '0' },
    { label: '30 Minutes', value: '00:30' },
    { label: '45 Minutes', value: '00:45' },
    { label: '1 Hour', value: '01:00' },
    { label: '1 Hour 30 Minutes', value: '01:30' },
    { label: '2 Hours', value: '02:00' },
    { label: '2 Hour 30 mins', value: '02:30' },
    { label: '3 Hours', value: '03:00' },
    { label: '4 Hours', value: '04:00' },
  ]

  function timeDifference(startTime, endTime) {
    // Parse the input strings as Date objects
    const startDate = new Date(`1970-01-01T${startTime}`).getTime();
    const endDate = new Date(`1970-01-01T${endTime}`).getTime();

    // Calculate the time difference in milliseconds
    const timeDiff = endDate - startDate;

    // Convert the time difference to hours, minutes, and seconds
    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    // Return the time difference as an object
    return {
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  }

  const setApiValuesToForm = (key, value) => {
    switch (key) {
      case 'shifts':
        {

          const shift1 = value[0];
          const shift2 = value[1];

          setStartTime(shift1.from)
          setEndTime(shift1.to)
          if (shift2) {

            // const timeToDiff = timeDifference(shift1.to, shift2.from)
            // const duration = dayjs.duration({ hours: timeToDiff.hours, minutes: timeToDiff.minutes });
            // const formattedDuration = dayjs.utc(duration.asMilliseconds()).format('HH:mm');
            // // setValue("breaks", { label: breakTimeList.find(t => t.value === formattedDuration)?.label, value: formattedDuration })
            // setBreakTime(shift1.to)
            // setEndTime(shift2.to)
          }
        }
        break;

      default:
        setValue(key, value);
        break;
    }
  }

  const onChangeOrganzation = (e) => {
    // showBreakStartTime(e.value === '0')

  };

  useEffect(() => {
    if (props.data) {
      Object.entries(props?.data).forEach(([key, value]) => {
        setApiValuesToForm(key, value);
      })
    }
  }, [props.data, props])

  const onBack = () => {
    reset();
    props.onCancel();
  };

  //   {
  //     "provider": "Ops",
  //     "name": "Test Shift 3",
  //     "description": "09:00-17:00",
  //     "shifts": [
  //         {
  //             "name": "09:00 - 10:00",
  //             "description": "For shift 1 description",
  //             "from": "09:00",
  //             "to": "13:00"
  //         }
  //     ]
  // }

  const onFinish = async (data) => {

    if (!selectedCompany) {
      message.error("Company code not selected");
      return;
    }
    if (!selectedCenter) {
      message.error("Center not selected");
      return;
    }

    const values = {
      ...data,
      start_time: dayjs(data?.start_time).format("HH:mm"),
      end_time: dayjs(data?.end_time).format("HH:mm"),
      breaks: data?.breaks[0].duration?.value === '0' ? [] :
        data?.breaks?.map(e => ({ breakStart_time: dayjs(e.breakStart_time).format("HH:mm"), duration: e.duration?.value }))
    }
    console.log("VAALUEES---->", values);
    let payload;
    if (values?.breaks?.length > 0) {
      let shiftStartTime = dayjs(values.start_time, "HH:mm");
      let shiftEndTime = dayjs(values.end_time, "HH:mm");
      let breakTimes = values?.breaks;//[{ break_timestart: "12:00", breakDuration: "01:00" },{ break_timestart: "14:30", breakDuration: "00:30" }];
      let shifts = [];
      breakTimes.forEach(breakTime => {
        let breakStartTime = dayjs(breakTime.breakStart_time, "HH:mm");
        let breakEndTime = breakStartTime.add(Number(breakTime.duration.split(':')[0]), 'hour').add(Number(breakTime.duration.split(':')[1]), 'minute');

        shifts.push({ from: shiftStartTime.format("HH:mm"), to: breakStartTime.format("HH:mm") });
        shiftStartTime = breakEndTime.clone();
      });
      shifts.push({ from: shiftStartTime.format("HH:mm"), to: shiftEndTime.format("HH:mm") });
      payload = {
        "provider": selectedCenter,
        "name": values.name,
        "shifts": shifts,
        "description": values.description,
      }
    } else {
      payload =
      {
        "shifts": [{
          "from": dayjs(values.start_time, "HH:mm").format("HH:mm"),
          "to": dayjs(values.end_time, "HH:mm").format("HH:mm"),
        }],
        "provider": selectedCenter,
        "name": values.name,
        "description": values.description,
      }
    }

    // console.log("PAYLOAD----->", payload);
    try {
      if (isNew) {
        await addShift(payload, selectedCompany)
      } else {
        await editShift(payload, selectedCompany)
      }
      reset();
      setLoader(false);
      message.success(`Shift ${isNew ? 'added' : 'updated'} successfully`);
      setSubmited(true);
      props.onSubmit()
    } catch (e) {
      setLoader(false);
      setisError(true);
      const { response } = e;

      setErrorMessage(response?.data?.error);
    }
  }

  const disabledTime = (time) => {
    return {
      disabledHours: () => Array.from({ length: 25 }, (_, index) => index).filter((hour) => hour <= parseInt(startTime?.split(':')?.[0])),
    }
  }

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      {loader && !isError && (
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Space size={24} className="w-100 text-center" direction="vertical">
              <Spin size="large" className="ag-fontSize32" />
              {/* <Paragraph className="ag-default fontWeight600 mb-0">Loading</Paragraph> */}
            </Space>
          </Col>
        </Row>
      )}
      {!submited ? (
        <>
          <Row gutter={24}>
            <Col span={18}>
              <InputField
                isRequired={true}
                fieldname="name"
                label="Name"
                control={control}
                rules={{
                  required: "Please enter shift name",
                }}
                iProps={{ placeholder: "Enter Shift Name" }}
                initValue=""
                validate={errors.name && "error"}
                validMessage={errors.name && errors.name.message}
              />
            </Col>
            <Col span={18}>
              <InputField
                fieldname="description"
                label="Description"
                control={control}
                iProps={{ placeholder: "Enter Description" }}
                initValue=""
              />
            </Col>
            <Col span={24}>
              <Row gutter={24}>
                <Col span={6}>
                  <TimeField
                    isRequired={true}
                    fieldname="start_time"
                    label="Start Time"
                    control={control}
                    rules={{
                      setValueAs: (value) => dayjs(value).format("HH:mm"),
                    }}
                    // initValue=""
                    iProps={{
                      format: "HH:mm",
                      required: "Please enter time"
                      // value: startTime && dayjs(startTime, "HH:mm") || "",
                      // onChange: (timeChange, timeString) => {
                      //   setStartTime(timeString)
                      // },
                    }}
                    // setValue={setValue}
                    validate={errors.start_time && "error"}
                    validMessage={
                      errors.start_time && errors.start_time.message
                    }
                  />
                </Col>
                <Col span={6}>
                  <TimeField
                    isRequired={true}
                    fieldname="end_time"
                    label="End Time"
                    control={control}
                    rules={{
                      setValueAs: (value) => dayjs(value).format("HH:mm"),
                    }}
                    // initValue=""
                    iProps={{
                      format: "HH:mm",
                      required: "Please enter time",
                      // value: endTime && dayjs(endTime, "HH:mm") || "",
                      // onChange: (timeChange, timeString) => {
                      //   setEndTime(timeString)
                      // },
                      disabledTime: disabledTime
                    }}
                    // setValue={setValue}
                    validate={errors.end_time && "error"}
                    validMessage={
                      errors.end_time && errors.end_time.message
                    }
                  />
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={8}>Break Duration</Col>
                {(fields?.length > 0 && _break[0]?.duration?.value !== '0') && (<Col span={16}>Start Time <span className="requiredAst">*</span></Col>)}
              </Row>
              <br />
              {fields.map((item, index) => (
                <Row gutter={24}>
                  <Col span={8}>
                    <ReactSelectField
                      control={control}
                      initialValue={_break[index]?.duration || ""}
                      // label="Duration"
                      fieldname={`breaks[${index}].duration`}
                      selectOption={_break[0]?.duration?.value !== '0' ? breakTimeList.filter((e, index) => index != 0) : breakTimeList}
                      onChange={(e) => onChangeOrganzation(e)}
                      // validate={errors.break && "error"}
                      // validMessage={errors.break && errors.break.message}
                      iProps={{ placeholder: "Select break time" }}
                    />
                  </Col>
                  {
                    _break[index]?.duration?.value !== '0' &&
                    <Col span={16} style={{ display: "flex", justifyContent: "start" }}>
                      <TimeField
                        width="150px"
                        isRequired={true}
                        fieldname={`breaks[${index}].breakStart_time`}
                        label=""
                        control={control}
                        rules={{
                          setValueAs: (value) => dayjs(value).format("HH:mm"),
                        }}
                        initValue=""
                        iProps={{
                          format: "HH:mm",
                          required: "Please enter time",
                          // value: breakTime && dayjs(breakTime, "HH:mm") || "",
                          // onChange: (timeChange, timeString) => {
                          //   setBreakTime(timeString)
                          // },
                          disabledTime: disabledTime
                        }}
                        // validate={errors.breaks[index].breakStart_time && "error"}
                        // validMessage={
                        //   errors.breaks[index].breakStart_time && errors.breaks[index].breakStart_time.message
                        // }
                      />
                      <Button
                        type="link"
                        size="large"
                        danger
                        style={{ fontSize: "18px", top: '-4px' }}
                        icon={<CloseSquareOutlined />}
                        onClick={() => {
                          fields.length == 1 ? reset({
                            breaks: defaultVal.breaks
                          }) : remove(index)
                        }} />
                      {(fields.length > 0 && index == fields.length - 1) && (
                        <Button
                          className="bp-border-btn"
                          icon={<PlusOutlined />}
                          style={{ marginTop: "7px" }}
                          onClick={() => {
                            append({ duration: { label: '', value: '' }, breakStart_time: "" });
                          }}>Add More</Button>
                      )}

                    </Col>
                  }
                </Row>
              ))}

            </Col>
          </Row>
          <Row gutter={24} justify="space-between">
            <Col>
              <Button className="ag-gray-button-outline" onClick={onBack}>
                Back
              </Button>
            </Col>
            <Col>
              <Button className="ag-green-button" htmlType="submit">
                {isNew ? 'Save' : 'Update'}
              </Button>
            </Col>
          </Row>
        </>
      ) :
        isError && (
          <>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Space
                  size={24}
                  className="w-100 text-center"
                  direction="vertical"
                >
                  <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                  <Paragraph className="ag-error fontWeight600 mb-0">
                    {errorMessage}
                  </Paragraph>
                </Space>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <Button
                  className="ag-gray-button-outline"
                  htmlType="button"
                  onClick={() => {
                    setSubmited(false);
                    setisError(false);
                  }}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </>
        )
      }
    </Form>
  );
};

export default modifyShift;
